// extracted by mini-css-extract-plugin
export default {"root":"esWQn","footnote":"_3Btpo"};